import React from 'react';
import { format } from 'date-fns';
import { parseUTC } from 'core/utils';
import { Wrapper, Text } from './orderSoonStyles';
import loadable from '@loadable/component';
const iconDims = { width: 40, height: 24 };
const OrderSoonIcon = loadable(() => import('./OrderSoonIcon'), {
	fallback: <div style={{ ...iconDims, marginRight: 5 }} />
});

export const formatDate = (d) => {
	const dt = parseUTC(d);
	return format(dt, 'MMMM do');
};

const OrderSoon = ({ initialShipmentString }) => {
	const msg = initialShipmentString.length === 0
		? "The cutoff for this month's shipment is almost here!"
		: initialShipmentString;
	return (
		<Wrapper>
			<OrderSoonIcon {...iconDims} />
			<Text><span>Order Soon</span> - {msg}</Text>
		</Wrapper>
	);
};

export default OrderSoon;
